export type ResetsuggestionState = {
    deleteUserLoading: boolean;
    deleteUserSuccess: boolean;  
    errorCode: string;  
    alarmId: string;
    deviceId: string;
};

export const initialResetSuggestion: ResetsuggestionState = {    
    deleteUserLoading: false,
    deleteUserSuccess: false,
    errorCode: '',
    alarmId: '',
    deviceId: '',
};
